// https://observablehq.com/@namitmohale/monthly-utilization-report@149
export default function define(runtime, observer) {
  const main = runtime.module();
  main.variable(observer()).define(["md"], function(md){return(
md`# Monthly Utilization Report`
)});
  main.variable(observer("chart")).define("chart", ["d3","width","height","titleText","titlePos","titleSize","xAxis","yAxis","previousMonthData","previousMonthLine","currentMonthData","currentMonthLine","margin","dotX","y1","dotRadius","y2","labelX","labelSize","x","parser"], function(d3,width,height,titleText,titlePos,titleSize,xAxis,yAxis,previousMonthData,previousMonthLine,currentMonthData,currentMonthLine,margin,dotX,y1,dotRadius,y2,labelX,labelSize,x,parser)
{
  const svg = d3.create("svg")
      .attr("viewBox", [0, 0, width, height]);
  
  svg.append('text')
     .text(titleText)
     .attr('y', titlePos)
     .attr('x', width/2)
  .attr("text-anchor", "middle")
    .style("alignment-baseline", "middle")
     .attr('font-size', titleSize)
     .attr('font-weight', 'bold');

  svg.append("g")
      .call(xAxis);

  svg.append("g")
      .call(yAxis);

  svg.append("path")
      .datum(previousMonthData)
      .attr("fill", "none")
      .attr("stroke", "grey")
      .attr("stroke-width", 1.5)
      .attr("stroke-linejoin", "round")
      .attr("stroke-linecap", "round")
      .attr("d", previousMonthLine);
  
  svg.append("path")
      .datum(currentMonthData)
      .attr("fill", "none")
      .attr("stroke", "steelblue")
      .attr("stroke-width", 2.5)
      .attr("stroke-linejoin", "round")
      .attr("stroke-linecap", "round")
      .attr("d", currentMonthLine);
  
  svg.selectAll("mydots")
    .data(currentMonthData)
    .enter()
    .append("circle")
    .attr("cx", width-margin.right+dotX)
    .attr("cy", y1)
    .attr("r", dotRadius)
    .style("fill", 'steelblue')
  svg.selectAll("mydots")
    .data(currentMonthData)
    .enter()
    .append("circle")
    .attr("cx", width-margin.right+dotX)
    .attr("cy", y2)
    .attr("r", dotRadius)
    .style("fill", 'grey')
            
  svg.selectAll("mylabels")
    .data(currentMonthData)
    .enter()
    .append("text")
    .attr("x", width-margin.right+labelX)
    .attr("y", y1)
    .style("fill", 'steelblue')
    .text('Current Month')
    .attr("text-anchor", "left")
    .style("alignment-baseline", "middle")
    .style("font-size", labelSize)
  svg.selectAll("mylabels")
    .data(currentMonthData)
    .enter()
    .append("text")
    .attr("x", width-margin.right+labelX)
    .attr("y", y2)
    .style("fill", 'grey')
    .text('Previous Month')
    .attr("text-anchor", "left")
    .style("alignment-baseline", "middle")
    .style("font-size", labelSize)
  
  svg.append("line")
    .attr("x1", x(parser("2021-01-19")))  //<<== change your code here
    .attr("y1", margin.top)
    .attr("x2", x(parser("2021-01-19")))  //<<== and here
    .attr("y2", height - margin.bottom)
    .style("stroke-width", 1)
    .style("stroke", "red")
    .style("fill", "none");

  return svg.node();
}
);
  main.variable(observer("wrap")).define("wrap", ["d3"], function(d3){return(
(text) => {
        const width=50
        text.each(function() {
          var text = d3.select(this),
              words = text.text().split(/\s+/).reverse(),
              word,
              line = [],
              lineNumber = 0,
              lineHeight = 1.1, // ems
              y = text.attr("y"),
              dy = parseFloat(text.attr("dy")),
              tspan = text.text(null).append("tspan").attr("x", 0).attr("y", y).attr("dy", dy + "em");
          while (words.length >0) {
              word=words.pop()
            line.push(word);
            tspan.text(line.join(" "));
            // if (tspan.node().getComputedTextLength() > width) {
              line.pop();
              tspan.text(line.join(" "));
              line = [word];
              tspan = text.append("tspan").attr("x", 0).attr("y", y-10).attr("dy", ++lineNumber * lineHeight + dy + "em").text(word);
            // }
          }
        });
      }
)});
  main.variable(observer("dotX")).define("dotX", function(){return(
20
)});
  main.variable(observer("y1")).define("y1", function(){return(
35
)});
  main.variable(observer("labelX")).define("labelX", function(){return(
40
)});
  main.variable(observer("y2")).define("y2", function(){return(
60
)});
  main.variable(observer("titlePos")).define("titlePos", function(){return(
20
)});
  main.variable(observer("dotRadius")).define("dotRadius", function(){return(
8
)});
  main.variable(observer("labelSize")).define("labelSize", function(){return(
16
)});
  main.variable(observer("titleText")).define("titleText", function(){return(
"Monthly Utilization"
)});
  main.variable(observer("titleSize")).define("titleSize", function(){return(
20
)});
  main.variable(observer("parser")).define("parser", ["d3"], function(d3){return(
d3.timeParse("%Y-%m-%d")
)});
  main.variable(observer("previousMonthData")).define("previousMonthData", ["parser"], function(parser){return(
[
  {
    date: parser("2021-01-01"), amount: 0
  },
  {
    date: parser("2021-01-02"), amount: 11
  },
  {
    date: parser("2021-01-03"), amount: 11
  },
  {
    date: parser("2021-01-04"), amount: 24.06
  },
  {
    date: parser("2021-01-05"), amount: 89.54
  },
  {
    date: parser("2021-01-06"), amount: 99.9
  },
  {
    date: parser("2021-01-07"), amount: 110.6
  },
  {
    date: parser("2021-01-08"), amount: 163.6
  },
  {
    date: parser("2021-01-09"), amount: 500.76
  },
  {
    date: parser("2021-01-10"), amount: 503.7
  },
  {
    date: parser("2021-01-11"), amount: 503.7
  },
  {
    date: parser("2021-01-12"), amount: 513.7
  },
  {
    date: parser("2021-01-13"), amount: 579
  },
  {
    date: parser("2021-01-14"), amount: 956.65
  },
  {
    date: parser("2021-01-15"), amount: 970
  },
  {
    date: parser("2021-01-16"), amount: 984
  },
  {
    date: parser("2021-01-17"), amount: 1100
  },
  {
    date: parser("2021-01-18"), amount: 1114
  },
  {
    date: parser("2021-01-19"), amount: 1167
  },
  {
    date: parser("2021-01-20"), amount: 1199
  },
  {
    date: parser("2021-01-21"), amount: 1365
  },
  {
    date: parser("2021-01-22"), amount: 1399
  },
  {
    date: parser("2021-01-23"), amount: 1595
  },
  {
    date: parser("2021-01-24"), amount: 1600
  },
  {
    date: parser("2021-01-25"), amount: 1743
  },
  {
    date: parser("2021-01-26"), amount: 2104
  },
  {
    date: parser("2021-01-27"), amount: 2189
  },
  {
    date: parser("2021-01-28"), amount: 2203
  },
  {
    date: parser("2021-01-29"), amount: 2267
  },
  {
    date: parser("2021-01-30"), amount: 2398
  },
  {
    date: parser("2021-01-31"), amount: 2800
  }
]
)});
  main.variable(observer("currentMonthData")).define("currentMonthData", ["parser"], function(parser){return(
[
  {
    date: parser("2021-01-01"), amount: 65
  },
  {
    date: parser("2021-01-02"), amount: 75
  },
  {
    date: parser("2021-01-03"), amount: 119
  },
  {
    date: parser("2021-01-04"), amount: 154
  },
  {
    date: parser("2021-01-05"), amount: 176
  },
  {
    date: parser("2021-01-06"), amount: 265
  },
  {
    date: parser("2021-01-07"), amount: 299
  },
  {
    date: parser("2021-01-08"), amount: 475
  },
  {
    date: parser("2021-01-09"), amount: 499
  },
  {
    date: parser("2021-01-10"), amount: 865
  },
  {
    date: parser("2021-01-11"), amount: 999
  },
  {
    date: parser("2021-01-12"), amount: 1165
  },
  {
    date: parser("2021-01-13"), amount: 1165
  },
  {
    date: parser("2021-01-14"), amount: 1589
  },
  {
    date: parser("2021-01-15"), amount: 1790
  },
  {
    date: parser("2021-01-16"), amount: 1864
  },
  {
    date: parser("2021-01-17"), amount: 1935
  },
  {
    date: parser("2021-01-18"), amount: 1999
  },
  {
    date: parser("2021-01-19"), amount: 2000
  }
]
)});
  main.variable(observer("x")).define("x", ["d3","previousMonthData","margin","width"], function(d3,previousMonthData,margin,width){return(
d3.scaleUtc()
    .domain(d3.extent(previousMonthData, d => d.date))
    .range([margin.left, width - margin.right])
)});
  main.variable(observer("y")).define("y", ["d3","previousMonthData","height","margin"], function(d3,previousMonthData,height,margin){return(
d3.scaleLinear()
    .domain([0, d3.max(previousMonthData, d => d.amount)]).nice()
    .range([height - margin.bottom, margin.top])
)});
  main.variable(observer("xAxis")).define("xAxis", ["height","margin","d3","x","width","xAxisTickSize"], function(height,margin,d3,x,width,xAxisTickSize){return(
g => g
    .attr("transform", `translate(0,${height - margin.bottom})`)
    .call(d3.axisBottom(x).ticks(width / 80).tickSizeOuter(0))
    .attr("font-size", xAxisTickSize)
)});
  main.variable(observer("yAxis")).define("yAxis", ["margin","d3","y","yAxisTickSize","yAxisLabelSize"], function(margin,d3,y,yAxisTickSize,yAxisLabelSize){return(
g => g
    .attr("transform", `translate(${margin.left},0)`)
    .call(d3.axisLeft(y))
    .attr("font-size", yAxisTickSize)
    .call(g => g.select(".domain").remove())
    .call(g => g.select(".tick:last-of-type text").clone()
        .attr("x", 3)
        .attr("text-anchor", "start")
        .attr("font-weight", "bold")
        .attr("font-size", yAxisLabelSize)
        .text("Amount ($)"))
)});
  main.variable(observer("xAxisTickSize")).define("xAxisTickSize", function(){return(
12
)});
  main.variable(observer("yAxisTickSize")).define("yAxisTickSize", function(){return(
11
)});
  main.variable(observer("yAxisLabelSize")).define("yAxisLabelSize", function(){return(
12
)});
  main.variable(observer("currentMonthLine")).define("currentMonthLine", ["d3","x","y"], function(d3,x,y){return(
d3.line()
    .defined(d => !isNaN(d.amount))
    .x(d => x(d.date))
    .y(d => y(d.amount))
)});
  main.variable(observer("previousMonthLine")).define("previousMonthLine", ["d3","x","y"], function(d3,x,y){return(
d3.line()
    .defined(d => !isNaN(d.amount))
    .x(d => x(d.date))
    .y(d => y(d.amount))
)});
  main.variable(observer("margin")).define("margin", function(){return(
{top: 40, right: 180, bottom: 30, left: 40}
)});
  main.variable(observer("height")).define("height", function(){return(
300
)});
  main.variable(observer("d3")).define("d3", ["require"], function(require){return(
require("d3@6")
)});
  return main;
}
